import { fmtTime } from '@concord/domain';

/** "Thu 11:00 AM" in the given zone. */
export const shortTime = (iso: string, tz: string) =>
  `${new Intl.DateTimeFormat('en-US', { weekday: 'short', timeZone: tz }).format(new Date(iso))} ${fmtTime(new Date(iso), tz)}`;

/**
 * A physician's accepted status. After the consultation is moved, the time they accepted is
 * history: say where it went instead of showing the old time as if it still stood.
 */
export function acceptedLabel(
  acceptedStartsAt: string | null,
  consultationStartsAt: string | null,
  tz: string,
) {
  if (!acceptedStartsAt) return 'Accepted';
  if (consultationStartsAt && Date.parse(consultationStartsAt) !== Date.parse(acceptedStartsAt)) {
    return `Accepted · moved to ${shortTime(consultationStartsAt, tz)}`;
  }
  return `Accepted ${shortTime(acceptedStartsAt, tz)}`;
}
